import React, { useState, useEffect } from "react";
import CartItem from "./CartItem";

import arrowDown from "../../images/icon/icon-arrow-down.png";
import arrowRight from "../../images/icon/icon-arrow-right.svg";

export default function CartList({
  list,
  viewList,
  page,
  setList,
  setViewList,
  setPage,
  addPresetItem,
}) {
  const [isUpDown, setViewType] = useState(
    !(window.innerHeight > window.innerWidth)
  );

  const getLength = () => {
    setViewType(!(window.innerHeight > window.innerWidth));
  };

  useEffect(() => {
    window.addEventListener("resize", getLength);
    return () => {
      window.addEventListener("resize", getLength);
    };
  }, []);

  function deletePresetItem(item) {
    const idx = list.indexOf(item);
    const newlist = [
      ...list.slice(0, idx),
      ...list.slice(idx + 1, list.length),
    ];
    if (viewList.length === 1) {
      setPage(page - 1);
      setViewList(newlist.slice(newlist.length - 3, newlist.length));
    } else {
      setViewList(newlist.slice(page * 3, (page + 1) * 3));
    }
    setList(newlist);
  }

  function countDownPresetItem(item) {
    const idx = list.indexOf(item);
    item.qty = item.qty - 1;
    item.totAmt = item.totAmt - item.price;
    setList([...list.slice(0, idx), item, ...list.slice(idx + 1, list.length)]);
  }

  function countCartPage(dir) {
    if (dir < 0) {
      if (page === 0) return;
      setPage(page - 1);
      setViewList([...list.slice((page - 1) * 3, page * 3)]);
    } else {
      if (page >= Math.ceil(list.length / 3) - 1) return;
      setPage(page + 1);
      setViewList([...list.slice((page + 1) * 3, (page + 2) * 3)]);
    }
  }

  return (
    <div className="left-area">
      <div className="add-list">
        <div className="add-list-header">
          <p>담은 상품</p>
          <p>{list.length}</p>
        </div>
        <img
          src={isUpDown ? arrowDown : arrowRight}
          className={page > 0 ? "page-up-active" : "page-up-inactive"}
          alt="page-before"
          onClick={() => countCartPage(-1)}
        />
        {list.length > 0 ? (
          <div className="add-list-body">
            {<div className="cart-list-before" />}
            {viewList.map((item, index) => (
              <CartItem
                key={index}
                item={item}
                add={addPresetItem}
                sub={countDownPresetItem}
                del={deletePresetItem}
              />
            ))}
            {page < Math.ceil(list.length / 3) - 1 && (
              <div className="cart-list-after" />
            )}
          </div>
        ) : (
          <div className="empty-list">
            <p>
              담은 상품이 없습니다.
              <br />
              상품을 추가하세요.
            </p>
          </div>
        )}
        <img
          src={isUpDown ? arrowDown : arrowRight}
          className={
            page < Math.ceil(list.length / 3) - 1
              ? "page-down-active"
              : "page-down-inactive"
          }
          alt="page-next"
          onClick={() => countCartPage(1)}
        />
      </div>
    </div>
  );
}
